
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#171C26","fill-rule":"evenodd","d":"M13.4.602v7.066c0 .957-.776 1.733-1.733 1.733H2.333A1.733 1.733 0 01.6 7.668V.602h12.8zm-1.29 3.18l-.12.06L7 6.098 2.01 3.841a2.398 2.398 0 01-.61-.397v4.224c0 .485.37.884.844.929l.09.004h9.333a.933.933 0 00.933-.933l.002-4.226a2.397 2.397 0 01-.492.34zm.49-2.381H1.4v.275l.007.125a1.6 1.6 0 00.829 1.26l.104.051L7 5.221l4.66-2.109a1.6 1.6 0 00.936-1.34l.004-.117V1.4z","clip-rule":"evenodd"}})])
          )
        }
      }
    